import { AllRoutes } from "../../Routes/router";

export const checkPermission = (path) => {
  let pname = Object.entries(AllRoutes).find(
    (ar) => ar?.[1]?.link?.toLowerCase() === path?.toLowerCase()
  )?.[1]?.pname;
  if (pname) {
    return pname;
  }
  debugger
  if (path === "/Dashboard") {
    return "Dashboard";
  } else if (path === "/UserRoleMapping") {
    return "UserRoleMappingDashboard";
  } else if (path === "/UserRoleMapping/edit") {
    return "UserRoleMapping";
  } else if (path === "/MemberRegistrationForm") {
    return "MemberRegistration";
  } else if (path === "/RegistrationRequest") {
    return "RegistrationRequest";
  } else if (path === "/RegistrationApproval") {
    return "RegistrationApproval";
  } else if (path === "/PaymentVerification") {
    return "PaymentVerification";
  } else if (path === "/PaymentVerificationView") {
    return "PaymentVerificationView";
  } else if (path === "/LoanModule") {
    return "LoanModule";
  } else if (path === "/DemandRecoveryForm") {
    return "DemandRecoveryForm";
  } else {
    return "";
  }
};
